import { Button, Flex, Typography } from 'antd'
import { useTheme } from 'antd-style'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAccountServiceRequestResetPasswordEndpoint } from 'src/api/queries'
import { RESET_EMAIL } from 'src/app-constants'
import { message, Text } from 'src/components'
import { useLocalStorage } from 'src/hooks'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { AuthHeader } from '../components'

const { Link } = Typography

export const ResetConfirm = () => {
  const [countdown, setCountdown] = useState(60)

  const { t } = useLocales()
  const navigate = useNavigate()

  const palette = useTheme()

  const { storedValue: resetEmail } = useLocalStorage(RESET_EMAIL, '')

  const { mutate, isPending } = useAccountServiceRequestResetPasswordEndpoint({
    onSuccess: () => {
      navigate(paths.auth.resetConfirm)
      message.success(t('auth.reset_password_request_success'))
    },
    onError: () => {
      message.error(t('auth.login_error'))
    }
  })

  const onSubmit = () => {
    mutate({
      requestBody: {
        email: resetEmail
      }
    })
  }

  const onResendClick = () => {
    if (countdown === 0) {
      setCountdown(60)
      onSubmit()
    }
  }

  useEffect(() => {
    let intervalId: NodeJS.Timeout

    if (countdown > 0) {
      intervalId = setInterval(() => {
        setCountdown((prevCount) => prevCount - 1)
      }, 1000)
    }

    return () => clearInterval(intervalId)
  }, [countdown])

  return (
    <Flex vertical gap={32}>
      <AuthHeader
        title={t('auth.check_email')}
        description={t('auth.check_email_subtitle')}
      />

      <Flex vertical gap={16}>
        <Flex gap={8} align="center" wrap>
          <Text color={palette.black.black1}>
            {t('auth.check_email_description')}
          </Text>

          <Link onClick={onResendClick}>
            <Button
              type="link"
              loading={isPending}
              style={{ padding: 0 }}
              disabled={countdown > 0}
            >
              <Text
                color={countdown > 0 ? palette.grey.grey1 : palette.orange}
                weight={600}
              >
                {t('auth.try_again')} {countdown > 0 && `(${countdown})`}
              </Text>
            </Button>
          </Link>
        </Flex>
      </Flex>
    </Flex>
  )
}
